import React from 'react';
import PropTypes from 'prop-types';
import { QuestionMarkLeft, QuestionMarkRight } from '../../helpers/icon-dictionary';
import {
  Wrapper,
  Text,
  Heading,
  Description } from './styled';
import SvgIcon from '../svg-icon/svg-icon';

const EmptyState = ({ i18n }) => (
  <Wrapper>
    <SvgIcon icon={QuestionMarkLeft} />
    <Text>
      <Heading>{i18n.t`Nothing to see?`}</Heading>
      <Description>{i18n.t`Select some topics and standards in the search
              bar above, and get ready to assign your heart out!`}
      </Description>
    </Text>
    <SvgIcon icon={QuestionMarkRight} />
  </Wrapper>
);

EmptyState.propTypes = {
  i18n: PropTypes.object
};

export default EmptyState;
